import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '大爱仙尊是一部什么样的小说？',
    answer: '大爱仙尊是一部仙侠题材的长篇小说，讲述了一个被宗门视为废柴的少年方尘，凭借一颗大爱之心踏上修炼之路，最终成为万界至尊仙尊的传奇故事。小说融合了修炼体系、热血战斗和深情缘线，是近年来最受欢迎的仙侠作品之一。',
  },
  {
    question: '大爱仙尊的核心修炼体系是什么？',
    answer: '大爱仙尊的核心修炼体系是"大爱无疆诀"，与传统以灵气为核心的修炼体系不同，它以大爱之心为根基。修炼分为九层：爱己、爱亲、爱友、爱师、爱道、爱邦、爱世、爱界、大爱无疆。爱的境界越高，修为越强。',
  },
  {
    question: '大爱仙尊的更新时间是什么时候？',
    answer: '大爱仙尊目前保持每日更新，最新章节通常在晚上8点到10点之间发布。如遇特殊情况延迟，会提前在公告中说明。建议关注本站，获取最新更新通知。',
  },
  {
    question: '大爱仙尊的主角方尘有哪些红颜知己？',
    answer: '大爱仙尊方尘共有三位主要的红颜知己：柳如烟（青云宗大师姐，温婉贤淑）、慕容冰（冰宫圣女，冷艳绝伦）、火灵儿（南荒火族公主，热烈奔放）。每一段情缘都是真心付出，是大爱仙尊修炼之路上不可分割的部分。',
  },
  {
    question: '大爱仙尊的十大至宝有哪些？',
    answer: '大爱仙尊的十大至宝包括：大爱仙剑、混沌珠、万灵图、时光沙漏、不灭金身、开天斧、造化鼎、九天玄琴、万象棋盘和因果轮回镜。每一件至宝都有独特的来历和不可思议的威能。',
  },
  {
    question: '如何在第一时间看到最新章节更新？',
    answer: '您可以通过以下方式获取最新更新：1）收藏本站并每日访问；2）关注大爱仙尊官方社交媒体账号；3）加入大爱仙尊读者交流群。我们会第一时间推送更新通知。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 font-bold">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于大爱仙尊，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-base text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}